import React, { FC } from 'react';
import { ISupportAgent } from '@sv-support-sdk/chat-shared-types/src/common/chat';

import Message from '../../../ui/Content/Message';
import NoticeDot from '../../../ui/NoticeDot';
import { TYPING_MESSAGE_ID } from '../../../../constants/messages';

import css from './style.module.scss';

interface ITypingProps {
  supportTyping: ISupportAgent;
}
const TypingBlock: FC<ITypingProps> = ({ supportTyping = { img: '' } }) => (
  <Message avatar={{ img: { src: supportTyping.img } }} id={TYPING_MESSAGE_ID}>
    <div className={css.typing_block}>
      <NoticeDot size="big" color="grey" />
      <NoticeDot size="big" color="grey" />
      <NoticeDot size="big" color="grey" />
    </div>
  </Message>
);
export default TypingBlock;
